import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const DeletePrizeDrawModal = ({ open, onClose, prizeDraw, onConfirm }) => {
  const [refundEntries, setRefundEntries] = useState(true);
  const [notifyUsers, setNotifyUsers] = useState(true);

  const handleConfirm = () => {
    onConfirm({
      refund: prizeDraw.entriesCount > 0 ? refundEntries : false,
      notify: prizeDraw.entriesCount > 0 ? notifyUsers : false,
    });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle
        id="delete-dialog-title"
        sx={{ display: "flex", alignItems: "center", gap: 2 }}
      >
        <WarningAmberIcon color="warning" fontSize="large" />
        <Typography component="span" variant="h6">
          Confirm Prize Draw Deletion
        </Typography>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          This prize draw has <strong>{prizeDraw?.entriesCount} entries</strong>
          . Please choose how to handle the deletion:
        </DialogContentText>

        <Box sx={{ mt: 3, mb: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={refundEntries}
                onChange={(e) => setRefundEntries(e.target.checked)}
                color="primary"
                inputProps={{
                  "aria-label": "Refund all entries to participants",
                }}
              />
            }
            label="Refund all entries to participants"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={notifyUsers}
                onChange={(e) => setNotifyUsers(e.target.checked)}
                color="primary"
                inputProps={{
                  "aria-label": "Notify participants about cancellation",
                }}
              />
            }
            label="Notify participants about cancellation"
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ minWidth: 100 }}
          aria-label="Cancel deletion"
        >
          Cancel
        </Button>

        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          startIcon={<DeleteOutlineIcon />}
          sx={{ minWidth: 100 }}
          aria-label="Confirm deletion"
        >
          Confirm Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePrizeDrawModal;
